"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_virtualized_1 = require("react-virtualized");
var Grid_1 = __importDefault(require("../Grid"));
var Loader_1 = __importDefault(require("./Loader"));
var Cell_1 = __importDefault(require("./Cell"));
var Pagination_1 = __importDefault(require("./Pagination"));
var useStyles_1 = __importDefault(require("./useStyles"));
var getColumnWidth_1 = __importDefault(require("./utils/getColumnWidth"));
var useRecomputerGridSize_1 = __importDefault(require("./hooks/useRecomputerGridSize"));
var useGetFixedRowCount_1 = __importDefault(require("./hooks/useGetFixedRowCount"));
var AutoSizer = react_virtualized_1.AutoSizer;
var MultiGrid = react_virtualized_1.MultiGrid;
var MultiGridContainer = function (props) {
    var fixedColumnCount = props.fixedColumnCount, scrollToColumn = props.scrollToColumn, scrollToRow = props.scrollToRow, columnWidth = props.columnWidth, getCellStyle = props.getCellStyle, enableFixedColumnScroll = props.enableFixedColumnScroll, enableFixedRowScroll = props.enableFixedRowScroll, rowHeight = props.rowHeight, rowCount = props.rowCount, style = props.style, styleBottomLeftGrid = props.styleBottomLeftGrid, styleTopLeftGrid = props.styleTopLeftGrid, styleTopRightGrid = props.styleTopRightGrid, hideTopRightGridScrollbar = props.hideTopRightGridScrollbar, hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar, filter = props.filter, isLoading = props.isLoading, _a = props.classes, classes = _a === void 0 ? {} : _a, translate = props.translate, data = props.data, columns = props.columns, 
    // Pagination
    _b = props.paging, 
    // Pagination
    paging = _b === void 0 ? false : _b, count = props.count, onChangePage = props.onChangePage, page = props.page, rowsPerPage = props.rowsPerPage;
    var columnCount = columns.length;
    var fixedRowCount = (0, useGetFixedRowCount_1.default)(columns);
    var multiGridRef = (0, react_1.useRef)();
    var internalClasses = (0, useStyles_1.default)();
    (0, useRecomputerGridSize_1.default)(multiGridRef, columnCount);
    return (react_1.default.createElement(Grid_1.default, { container: true, direction: "column", classes: { root: internalClasses.container } },
        isLoading && react_1.default.createElement(Loader_1.default, null),
        filter && react_1.default.createElement(Grid_1.default, { item: true }, filter),
        react_1.default.createElement(Grid_1.default, { item: true, xs: true },
            react_1.default.createElement(AutoSizer, null, function (_a) {
                var height = _a.height, width = _a.width;
                return (react_1.default.createElement(MultiGrid, { ref: multiGridRef, fixedColumnCount: fixedColumnCount, fixedRowCount: fixedRowCount, scrollToColumn: scrollToColumn, scrollToRow: scrollToRow, cellRenderer: function (cellRendererProps) { return (react_1.default.createElement(Cell_1.default, __assign({}, cellRendererProps, { cellKey: cellRendererProps.key, fixedRowCount: fixedRowCount, data: data, columns: columns, getCellStyle: getCellStyle }))); }, columnWidth: (0, getColumnWidth_1.default)(width, columnWidth, columnCount), columnCount: columnCount, enableFixedColumnScroll: enableFixedColumnScroll, enableFixedRowScroll: enableFixedRowScroll, height: height, rowHeight: rowHeight, rowCount: rowCount, style: style, styleBottomLeftGrid: styleBottomLeftGrid, styleTopLeftGrid: styleTopLeftGrid, styleTopRightGrid: styleTopRightGrid, width: width, hideTopRightGridScrollbar: hideTopRightGridScrollbar, hideBottomLeftGridScrollbar: hideBottomLeftGridScrollbar }));
            })),
        paging && (react_1.default.createElement(Grid_1.default, { item: true },
            react_1.default.createElement(Pagination_1.default, { count: count, onChangePage: onChangePage, page: page, rowsPerPage: rowsPerPage, classes: classes.pagination, translate: translate })))));
};
exports.default = MultiGridContainer;
